import type {
  BalanceSheetTotalType,
  CostOfGoodsType,
  DetailedProfitLossDataType,
  IncomeExpenseProfitData,
  MonthlyLedgerSummaryTotalsDataType,
  ReceiptAndPaymentType,
  RelatedPartyReportTotalsType,
  ReportsType,
  TotalBalancetype,
  TotalBatchSummaryDataType,
  TotalBatchVoucherDataType,
  TotalDebitCreditAmountType,
  TotalProfitLossBalanceType,
  TotalStockReportsSummaryDataType,
  TotalStockStatementDataType,
} from "@/redux/reports/reportsType";

export const initialState: ReportsType = {
  fetching: false,
  success: null,
  error: null,
  ledgerStatementCount: 0,
  closingBalance: 0,
  openingBalance: 0,
  totalDebitCreditAmount: {} as TotalDebitCreditAmountType,
  ledgerStatement: [],
  trialBalance: [],
  expenseProfitLoss: [],
  revenueProfitLoss: [],
  assetsBalanceSheetData: [],
  liabilitiesBalanceSheetData: [],
  equityBalanceSheetData: [],
  paymentBalanceSheetData: [],
  customerBalanceSheetData: [],
  supplierBalanceSheetData: [],
  taxPayableBalanceSheetData: [],
  taxReceivableBalanceSheetData: [],
  detailedProfitLossData: {} as DetailedProfitLossDataType,
  detailedBalanceSheetData: {} as any,
  detailedTrialBalance: {} as any,
  detailedNatureOfIncomeExpense: null,
  stockReportsSummaryData: [],
  stockStatementData: [],
  totalStockStatementData: {} as TotalStockStatementDataType,
  totalStockReportsSummaryData: {} as TotalStockReportsSummaryDataType,
  totalProfitLossBalance: {} as TotalProfitLossBalanceType,
  balanceSheetTotal: {} as BalanceSheetTotalType,
  statusCode: null,
  totalBalances: {} as TotalBalancetype,
  dayBookListData: [],
  generalLedgerListData: [],
  costOfGoods: {} as CostOfGoodsType,
  stockSummaryBalanceSheetData: [],
  ageingAnalysisList: [],
  ageingAnalysisTotalCount: 0,
  receiptAndPayment: {} as ReceiptAndPaymentType,
  ageingAnalysis0To30DaysTotal: 0,
  ageingAnalysis30To60DaysTotal: 0,
  ageingAnalysis60To90DaysTotal: 0,
  ageingAnalysis90To180DaysTotal: 0,
  ageingAnalysis180To365DaysTotal: 0,
  ageingAnalysisMoreThan365DaysTotal: 0,
  ageingAnalysisTotalOfTotal: 0,
  stocklimitData: [],
  stockLimitTotalCount: 0,
  batchSummaryReportData: [],
  totalBatchSummaryData: {} as TotalBatchSummaryDataType,
  batchVoucherData: [],
  totalBatchVoucherData: {} as TotalBatchVoucherDataType,
  monthlyLedgerSummaryTotal: {} as MonthlyLedgerSummaryTotalsDataType,
  monthlyLedgerSummaryData: [],
  generalLedgerDownloadHistory: [],
  generalLedgerDownloadHistoryTotalCount: 0,

  incomeExpenseProfitList: {} as IncomeExpenseProfitData,
  incomeExpenseFetching: false,
  incomeExpenseSuccess: null,

  salesPerformanceList: [],
  expensePerformanceList: [],
  salesPerformanceFetching: false,
  expensePerformanceFetching: false,
  ledgerInsightData: {} as any,
  ledgerInsightFetching: false,
  relatedPartyReportList: [],
  relatedPartyReportTotalCount: 0,
  relatedPartyReportTotals: {} as RelatedPartyReportTotalsType,
};
